// Breadcrumbs.js
import React, { useContext } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { Breadcrumbs as MuiBreadcrumbs, Typography } from "@mui/material";
import { RoleContext } from "../lib/contexts/RoleContext";

const Breadcrumb = () => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);
  const { role } = useContext(RoleContext);
  const {
    cohortId,
    quizId,
    evaluationId,
    courseId,
    masterId,
    versionId,
    assetId,
  } = useParams();

  const isInPrismRole = role === "prism";

  const dashboardListLabel = isInPrismRole ? "listOfAssets" : "listOfQuizzes";


  const breadcrumbItems = [
    { name: "Home", path: "/" },
    ...(versionId &&!pathnames.includes("performanceDashboard")
      ? [
        {
          name: "Versions",
          // path: `/cohort/${cohortId}/quiz/${quizId}/versions`,
          path: `/asset/${assetId}/versions`,
        },
      ]
      : []),
    ...(masterId ? [{ name: "MasterSolution", path: "/masterSolution" }] : []),
    ...(quizId && !pathnames.includes("performanceDashboard") && !isInPrismRole
      ? [{ name: `Quizzes`, path: `/cohort/${cohortId}/quizzes` }]
      : []),
    ...(evaluationId && !pathnames.includes("performanceDashboard")
      ? versionId ? [
        {
          name: `Evaluations`,
          path: `/cohort/${cohortId}/quiz/${quizId}/asset/${assetId}/version/${versionId}/evaluations`,
        },
      ] : [
        {
          name: `Evaluations`,
          path: `/cohort/${cohortId}/quiz/${quizId}/evaluations`,
        },
      ]
      : []),
    // ...(pathnames.includes('listOfQuizzes') ? [{ name: 'PerformanceDashboard', path: '/performanceDashboard' }] : []),
    // ...(pathnames.includes('listOfQuizzes/cohort') ? [{ name: 'listOfQuizzes', path: '/performanceDashboard/listOfQuizzes' }] : []),
    ...(pathnames.includes("listOfQuizzes")
      ? [{ name: "performanceDashboard", path: "/performanceDashboard" }]
      : []),
      ...(pathnames.includes("evaluationsFailedReport")
      ? [{ name: "performanceDashboard", path: "/performanceDashboard" }]
      : []),
      ...(pathnames.includes("evaluationsQueueReport")
      ? [{ name: "performanceDashboard", path: "/performanceDashboard" }]
      : []),
      ...(pathnames.includes("evaluationsNotStartedReport")
      ? [{ name: "performanceDashboard", path: "/performanceDashboard" }]
      : []),

    // ...(courseId && quizId && pathnames.includes("listOfQuizzes")
    //   ? [
    //     {
    //       name: "listOfQuizzes",
    //       path: `/performanceDashboard/listOfQuizzes`,
    //     },
    //   ]
    //   : []),
    ...(courseId && quizId && (pathnames.includes("listOfQuizzes"))
  ? [
      {
        name: dashboardListLabel,
        path: `/performanceDashboard/listOfQuizzes`,
      },
    ]
  : []),
    ...(evaluationId && pathnames.includes("performanceDashboard")
      ? [
        {
          name: `Evaluations`,
          path: `/performanceDashboard/listOfQuizzes/cohort/${courseId}/quiz/${quizId}/evaluations`,
        },
      ]
      : []),
  ];
  const lastPathname = pathnames[pathnames.length - 1];
  const displayName = lastPathname === "listOfQuizzes" 
    ? (isInPrismRole ? "listOfAssets" : "listOfQuizzes")
    : lastPathname;


  return (
    <MuiBreadcrumbs aria-label="breadcrumb">
      {breadcrumbItems.map((item, index) => (
        <Link key={index} to={item.path}>
          {item.name}
        </Link>
      ))}
      <Typography color="text.primary" textTransform={"capitalize"}>
        {/* {pathnames[pathnames.length - 1]} */}
        {displayName}
      </Typography>
    </MuiBreadcrumbs>
  );
};

export default Breadcrumb;
